import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getColorById } from '../../commons/colors';
var activeTabsStyles = css([":after{background-color:", ";}"], function (_ref) {
  var theme = _ref.theme,
    $colorId = _ref.$colorId;
  return getColorById(theme, $colorId || 'terciaryD');
});
var activeChipsStyles = css([":after{padding:0;", " border:1px solid ", ";background-color:", ";font-weight:500;}"], function (_ref2) {
  var $withIcon = _ref2.$withIcon;
  return $withIcon && 'padding-left: 32px;';
}, function (_ref3) {
  var theme = _ref3.theme,
    _ref3$$colorId = _ref3.$colorId,
    $colorId = _ref3$$colorId === void 0 ? 'terciaryD' : _ref3$$colorId;
  return getColorById(theme, $colorId);
}, function (_ref4) {
  var theme = _ref4.theme,
    _ref4$$colorId = _ref4.$colorId,
    $colorId = _ref4$$colorId === void 0 ? 'terciaryDD' : _ref4$$colorId;
  return getColorById(theme, $colorId, 25);
});
var activeChipsPlusStyles = css([":after{padding:0;", " border:1px solid ", ";background-color:", ";color:", ";}"], function (_ref5) {
  var $withIcon = _ref5.$withIcon;
  return $withIcon && 'padding-left: 32px;';
}, function (_ref6) {
  var theme = _ref6.theme,
    _ref6$$colorId = _ref6.$colorId,
    $colorId = _ref6$$colorId === void 0 ? 'terciaryD' : _ref6$$colorId;
  return getColorById(theme, $colorId);
}, function (_ref7) {
  var theme = _ref7.theme,
    _ref7$$colorId = _ref7.$colorId,
    $colorId = _ref7$$colorId === void 0 ? 'terciaryDD' : _ref7$$colorId;
  return getColorById(theme, $colorId, 100);
}, function (_ref8) {
  var theme = _ref8.theme,
    _ref8$$titleColorId = _ref8.$titleColorId,
    $titleColorId = _ref8$$titleColorId === void 0 ? 'terciaryDD' : _ref8$$titleColorId;
  return getColorById(theme, $titleColorId, 25);
});
var activeModulesPlusStyles = css(["background-color:", ";color:", ";path{fill:", ";}rect,circle{stroke:", ";}path.inverse{stroke:", ";fill:none;}rect.inverse{fill:", ";stroke:none;}"], function (_ref9) {
  var theme = _ref9.theme,
    _ref9$$colorId = _ref9.$colorId,
    $colorId = _ref9$$colorId === void 0 ? 'terciaryDD' : _ref9$$colorId;
  return getColorById(theme, $colorId, 100);
}, function (_ref10) {
  var theme = _ref10.theme,
    _ref10$$titleColorId = _ref10.$titleColorId,
    $titleColorId = _ref10$$titleColorId === void 0 ? 'terciaryDD' : _ref10$$titleColorId;
  return getColorById(theme, $titleColorId, 25);
}, function (_ref11) {
  var theme = _ref11.theme,
    _ref11$$titleColorId = _ref11.$titleColorId,
    $titleColorId = _ref11$$titleColorId === void 0 ? 'terciaryDD' : _ref11$$titleColorId;
  return getColorById(theme, $titleColorId, 25);
}, function (_ref12) {
  var theme = _ref12.theme,
    _ref12$$titleColorId = _ref12.$titleColorId,
    $titleColorId = _ref12$$titleColorId === void 0 ? 'terciaryDD' : _ref12$$titleColorId;
  return getColorById(theme, $titleColorId, 25);
}, function (_ref13) {
  var theme = _ref13.theme,
    _ref13$$titleColorId = _ref13.$titleColorId,
    $titleColorId = _ref13$$titleColorId === void 0 ? 'terciaryDD' : _ref13$$titleColorId;
  return getColorById(theme, $titleColorId, 25);
}, function (_ref14) {
  var theme = _ref14.theme,
    _ref14$$titleColorId = _ref14.$titleColorId,
    $titleColorId = _ref14$$titleColorId === void 0 ? 'terciaryDD' : _ref14$$titleColorId;
  return getColorById(theme, $titleColorId, 25);
});
var activeLinksStyles = css([":after{padding:0;font-weight:500;}"]);
var activeStyles = css(["opacity:1;", ";", ";", ";", ";", ";"], function (_ref15) {
  var $variant = _ref15.$variant;
  return $variant === 'tabs' && activeTabsStyles;
}, function (_ref16) {
  var $variant = _ref16.$variant;
  return $variant === 'chips' && activeChipsStyles;
}, function (_ref17) {
  var $variant = _ref17.$variant;
  return $variant === 'chipsPlus' && activeChipsPlusStyles;
}, function (_ref18) {
  var $variant = _ref18.$variant;
  return $variant === 'modulesPlus' && activeModulesPlusStyles;
}, function (_ref19) {
  var $variant = _ref19.$variant;
  return $variant === 'links' && activeLinksStyles;
});
var disabledStyles = css(["opacity:0.4;cursor:not-allowed;"]);
var tabsStyles = css(["position:relative;opacity:0.9;padding:10px;border-bottom:1px solid ", ";color:", ";:hover{", ";}:after{position:absolute;bottom:-1px;left:-1px;right:-1px;opacity:1;height:3px;border-radius:4px;content:'';transition:all 0.5s ease;}"], function (_ref20) {
  var theme = _ref20.theme,
    $colorId = _ref20.$colorId;
  return getColorById(theme, $colorId || 'terciaryD', 99);
}, function (_ref21) {
  var theme = _ref21.theme,
    _ref21$$titleColorId = _ref21.$titleColorId,
    $titleColorId = _ref21$$titleColorId === void 0 ? 'terciaryD' : _ref21$$titleColorId;
  return getColorById(theme, $titleColorId);
}, function (_ref22) {
  var $isActive = _ref22.$isActive,
    theme = _ref22.theme,
    $colorId = _ref22.$colorId;
  return !$isActive ? "border-bottom: 1px solid ".concat(getColorById(theme, $colorId || 'terciaryD'), ";") : '';
});
var chipsStyles = css(["", ";position:relative;opacity:0.9;height:", ";padding:4px 10px;border-radius:16px;margin:0 4px 10px;color:", ";figure{display:inline-block;position:absolute;width:24px;height:24px;margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;img{width:100%;height:100%;}}span{visibility:hidden;", "}:after{position:absolute;top:0;bottom:0;left:0;right:0;opacity:1;height:26px;height:", ";padding:1px 0;border-radius:16px;content:", ";background-color:", ";line-height:23px;line-height:", ";text-align:center;", "}&:first-child{margin-left:0;}:hover{", ";}"], getFont('-1', 'compact'), function (_ref23) {
  var $withIcon = _ref23.$withIcon;
  return $withIcon ? '32px' : '26px';
}, function (_ref24) {
  var theme = _ref24.theme,
    _ref24$$titleColorId = _ref24.$titleColorId,
    $titleColorId = _ref24$$titleColorId === void 0 ? 'terciaryD' : _ref24$$titleColorId;
  return getColorById(theme, $titleColorId);
}, function (_ref25) {
  var $withIcon = _ref25.$withIcon;
  return $withIcon && 'padding-left: 32px;';
}, function (_ref26) {
  var $withIcon = _ref26.$withIcon;
  return $withIcon ? '32px' : '24px';
}, function (_ref27) {
  var $content = _ref27.$content;
  return JSON.stringify($content || '');
}, function (_ref28) {
  var theme = _ref28.theme,
    _ref28$$titleColorId = _ref28.$titleColorId,
    $titleColorId = _ref28$$titleColorId === void 0 ? 'terciaryD' : _ref28$$titleColorId;
  return getColorById(theme, $titleColorId, 10);
}, function (_ref29) {
  var $withIcon = _ref29.$withIcon;
  return $withIcon ? '30px' : '23px';
}, function (_ref30) {
  var $withIcon = _ref30.$withIcon;
  return $withIcon && 'padding-left: 32px;';
}, function (_ref31) {
  var $isActive = _ref31.$isActive,
    theme = _ref31.theme,
    $colorId = _ref31.$colorId;
  return !$isActive ? "background-color: ".concat(getColorById(theme, $colorId || 'terciaryD', 45), ";") : '';
});
var chipsPlusStyles = css(["", ";font-weight:300;position:relative;height:", ";padding:4px 14px;border-radius:16px;margin:0 4px 10px;color:", ";figure{display:inline-block;position:absolute;width:24px;height:24px;margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;img{width:100%;height:100%;}}span{visibility:hidden;", "}:after{position:absolute;top:0;bottom:0;left:0;right:0;opacity:1;height:26px;height:", ";padding:1px 0;border-radius:16px;content:", ";background-color:", ";line-height:23px;line-height:", ";text-align:center;", "}&:first-child{margin-left:0;}"], getFont(0, 'compact'), function (_ref32) {
  var $withIcon = _ref32.$withIcon;
  return $withIcon ? '32px' : '26px';
}, function (_ref33) {
  var theme = _ref33.theme;
  return getColorById(theme, 'terciaryD', 80);
}, function (_ref34) {
  var $withIcon = _ref34.$withIcon;
  return $withIcon && 'padding-left: 32px;';
}, function (_ref35) {
  var $withIcon = _ref35.$withIcon;
  return $withIcon ? '32px' : '24px';
}, function (_ref36) {
  var $content = _ref36.$content;
  return JSON.stringify($content || '');
}, function (_ref37) {
  var theme = _ref37.theme;
  return getColorById(theme, 'terciaryD', 10);
}, function (_ref38) {
  var $withIcon = _ref38.$withIcon;
  return $withIcon ? '30px' : '23px';
}, function (_ref39) {
  var $withIcon = _ref39.$withIcon;
  return $withIcon && 'padding-left: 32px;';
});
var modulesPlusStyles = css(["font-weight:300;position:relative;height:42px;padding:4px 6px 4px 14px;margin:0 0 8px;color:black;min-width:150px;background-color:", ";line-height:42px;border-radius:7.5px;align-content:center;", " &:first-child{margin-left:0;}span{width:100%;display:flex;justify-content:space-between;svg{margin-left:8px;}}", ""], function (_ref40) {
  var theme = _ref40.theme;
  return getColorById(theme, 'terciaryD', 10);
}, getFont(0.9, 'compact'), maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: fit-content;\n    ", "\n\n    &:not(:first-child) {\n      margin-left: 10px;\n    }\n\n    span {\n      min-width: 150px;\n    }\n  "])), getFont(0.5, 'compact')));
var linksStyles = css(["", ";position:relative;opacity:1;padding:4px 2px;margin:0 4px 10px;color:", ";transition:opacity 0.25s ease;span{visibility:hidden;}:after{position:absolute;top:0;bottom:0;left:0;right:0;opacity:1;content:", ";text-align:center;}:hover{opacity:0.85;:after{font-weight:500;}}&:first-child{margin-left:0;}"], getFont('0', 'compact'), function (_ref41) {
  var theme = _ref41.theme;
  return theme.linkColor;
}, function (_ref42) {
  var $content = _ref42.$content;
  return JSON.stringify($content || '');
});
var columnsStyles = css(["position:relative;opacity:1;width:158px;height:85px;margin:2px 0;", ";background-color:", ";color:", ";text-align:center;transition:opacity 0.25s ease;display:flex;flex-direction:column;justify-content:center;align-items:center;figure > img{vertical-align:middle;}span{display:none;}:hover{opacity:0.85;:after{font-weight:500;}}"], getFont('0', 'compact'), function (_ref43) {
  var theme = _ref43.theme;
  return theme.colors.accent1LL;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.linkColor;
});
export var StyledItem = styled.div.withConfig({
  displayName: "StyledItem",
  componentId: "sc-1nfcjjx-0"
})(["display:block;cursor:pointer;white-space:nowrap;user-select:none;", ";", ";", ";", ";", ";", ";", " ", ""], function (_ref45) {
  var $variant = _ref45.$variant;
  return $variant === 'tabs' && tabsStyles;
}, function (_ref46) {
  var $variant = _ref46.$variant;
  return $variant === 'chips' && chipsStyles;
}, function (_ref47) {
  var $variant = _ref47.$variant;
  return $variant === 'chipsPlus' && chipsPlusStyles;
}, function (_ref48) {
  var $variant = _ref48.$variant;
  return $variant === 'modulesPlus' && modulesPlusStyles;
}, function (_ref49) {
  var $variant = _ref49.$variant;
  return $variant === 'links' && linksStyles;
}, function (_ref50) {
  var $variant = _ref50.$variant;
  return $variant === 'columns' && columnsStyles;
}, function (_ref51) {
  var $isActive = _ref51.$isActive;
  return $isActive && activeStyles;
}, function (_ref52) {
  var _ref52$disabled = _ref52.disabled,
    disabled = _ref52$disabled === void 0 ? false : _ref52$disabled;
  return disabled && disabledStyles;
});